import Portal = require("portal-gis");
import Base = require("./base-collection");

class Collection extends Base<Portal.FeatureLeaf> {
    static about = `Features`;
}

export = Collection; 